import Star from "./Star";

export default function RatingStars({ count = 1 }) {
    let stars = [];
    for (let i = 1; i <= count; i++) 
        stars.push(i);

	return (
        <>
            {stars.map(s => <Star key={s} />)}
        </>
	);
}
